import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AlertComponent {
    @Input() public mode:
        'default' | 'success' | 'info' | 'warning' | 'danger' = 'default';

    @Input() public label!: string;

    @Input() public description?: string;
}
